import { ProductField } from './types/master-data-setting-types';

export const COMMISSION_TOOL_BASE_PATH = '/commission-tool';
export const MASTER_DATA_SETTING_PATH = '/master-data-setting';
export const CONTRACT_SETTING_PATH = '/contract-setting';

export const COMMISSION_TOOL_TITLE = 'title.commission-tool';
export const MASTER_DATA_SETTING_TITLE = 'title.master.data.setting';
export const CONTRACT_SETTING_TITLE = 'title.contract.setting';

export const MASTER_DATA_SETTING_NAMESPACE = 'COMMISSION-MASTER-DATA';
export const CONTRACT_SETTING_NAMESPACE = 'COMMISSION-CONTRACT';

export enum AdminCommissionToolPermissionType {
  MASTER_DATA_SETTING_READ = 'READ_ANY_COMMISSION-MASTER-DATA',
  MASTER_DATA_SETTING_CREATE = 'CREATE_ANY_COMMISSION-MASTER-DATA',
  MASTER_DATA_SETTING_UPDATE = 'UPDATE_ANY_COMMISSION-MASTER-DATA',
  CONTRACT_SETTING_READ = 'READ_ANY_COMMISSION-CONTRACT',
  CONTRACT_SETTING_CREATE = 'CREATE_ANY_COMMISSION-CONTRACT',
  CONTRACT_SETTING_UPDATE = 'UPDATE_ANY_COMMISSION-CONTRACT',
  CONTRACT_SETTING_DELETE = 'DELETE_ANY_COMMISSION-CONTRACT',
}

export const LanguageKey = {
  [ProductField.PRODUCT_NAME]: 'master.data.setting.name.PRODUCT_NAME',
  [ProductField.INSURANCE_PLAN]: 'master.data.setting.name.INSURANCE_PLAN',
  [ProductField.INSURANCE_PREMIUM]: 'master.data.setting.name.INSURANCE_PREMIUM',
  [ProductField.PAYMENT_TERM]: 'master.data.setting.name.PAYMENT_TERM',
  [ProductField.PAYMENT_FREQUENCY]: 'master.data.setting.name.PAYMENT_FREQUENCY',
  [ProductField.EFFECTIVE_DATE]: 'master.data.setting.name.EFFECTIVE_DATE',
  [ProductField.PAYMENT_YEAR]: 'master.data.setting.name.PAYMENT_YEAR',
  [ProductField.RIDER_COUNT]: 'master.data.setting.name.RIDER_COUNT',
} as const;

// lists options for master data setting name
export const MasterDataNameOptions: Array<{ value: ProductField; labelKey: string }> = [
  {
    value: ProductField.PRODUCT_NAME,
    labelKey: LanguageKey[ProductField.PRODUCT_NAME],
  },
  {
    value: ProductField.INSURANCE_PLAN,
    labelKey: LanguageKey[ProductField.INSURANCE_PLAN],
  },
  {
    value: ProductField.INSURANCE_PREMIUM,
    labelKey: LanguageKey[ProductField.INSURANCE_PREMIUM],
  },
  {
    value: ProductField.PAYMENT_TERM,
    labelKey: LanguageKey[ProductField.PAYMENT_TERM],
  },
  {
    value: ProductField.PAYMENT_FREQUENCY,
    labelKey: LanguageKey[ProductField.PAYMENT_FREQUENCY],
  },
  {
    value: ProductField.PAYMENT_YEAR,
    labelKey: LanguageKey[ProductField.PAYMENT_YEAR],
  },
  {
    value: ProductField.EFFECTIVE_DATE,
    labelKey: LanguageKey[ProductField.EFFECTIVE_DATE],
  },
  {
    value: ProductField.RIDER_COUNT,
    labelKey: LanguageKey[ProductField.RIDER_COUNT],
  },
];

export const ContractSettingFieldDefinitions: Array<{
  fieldKey:
    | 'productNameId'
    | 'insurancePlanId'
    | 'insurancePremiumId'
    | 'premiumPaymentTermId'
    | 'premiumPaymentFrequencyId'
    | 'premiumPaymentYearId'
    | 'effectiveDateId'
    | 'riderCountId';
  masterDataName: ProductField;
  labelKey: string;
}> = [
  {
    fieldKey: 'productNameId',
    masterDataName: ProductField.PRODUCT_NAME,
    labelKey: LanguageKey[ProductField.PRODUCT_NAME],
  },
  {
    fieldKey: 'insurancePlanId',
    masterDataName: ProductField.INSURANCE_PLAN,
    labelKey: LanguageKey[ProductField.INSURANCE_PLAN],
  },
  {
    fieldKey: 'insurancePremiumId',
    masterDataName: ProductField.INSURANCE_PREMIUM,
    labelKey: LanguageKey[ProductField.INSURANCE_PREMIUM],
  },
  {
    fieldKey: 'premiumPaymentTermId',
    masterDataName: ProductField.PAYMENT_TERM,
    labelKey: LanguageKey[ProductField.PAYMENT_TERM],
  },
  {
    fieldKey: 'premiumPaymentFrequencyId',
    masterDataName: ProductField.PAYMENT_FREQUENCY,
    labelKey: LanguageKey[ProductField.PAYMENT_FREQUENCY],
  },
  {
    fieldKey: 'premiumPaymentYearId',
    masterDataName: ProductField.PAYMENT_YEAR,
    labelKey: LanguageKey[ProductField.PAYMENT_YEAR],
  },
  {
    fieldKey: 'effectiveDateId',
    masterDataName: ProductField.EFFECTIVE_DATE,
    labelKey: LanguageKey[ProductField.EFFECTIVE_DATE],
  },
  {
    fieldKey: 'riderCountId',
    masterDataName: ProductField.RIDER_COUNT,
    labelKey: LanguageKey[ProductField.RIDER_COUNT],
  },
];

export enum ErrorCodes {
  'Generic-3' = 'Generic-3',
  'Generic-2' = 'Generic-2',
}
